import { Component, OnInit, ViewChild } from '@angular/core';
import { Asset } from 'src/app/models/asset';
import { HttpService } from '../../shared/services/http.service';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { AssetFile } from 'src/app/models/assetFile';
import { ConfigService } from 'src/app/shared/services/config.service';
import { LibraryBrowserComponent } from '../library-browser/library-browser.component';

@Component({
  selector: 'app-personal-browser',
  templateUrl: './personal-browser.component.html',
  styleUrls: ['./personal-browser.component.css']
})

export class PersonalBrowserComponent implements OnInit {

  library: any;
  asset: Asset = new Asset();
  formats = [];
  quality = [];
  textureQuality = [];
  assetFilePath: string = "";
  loadAsset = true;
  searchKey = '';

  @ViewChild('libBrowser') libBrowser: LibraryBrowserComponent;
  theme_color: string;

  constructor(public httpService: HttpService, private userService: UserService, private config: ConfigService) { }

  ngOnInit() {
    let User = JSON.parse(sessionStorage.getItem('userinfo'));
    this.theme_color = User.userSettings.userThemeType===0?'dark':'light';
    this.config.searchActive = false;
    this.config.homeActive = false;
    this.config.uploadAssetsActive = false;

    this.config.personalBrowserActive = true;

    this.config.changeTab(2);
    this.httpService.getBasePath().then(e => {
      this.httpService.getPersonalBrowserStructure().subscribe(
        data => {
          this.library = data;
        }, error => {
          console.log(error);
        }
      );
    });

  }

  selectAsset(id: string) {
    if (id === "@folder") {
      this.asset = new Asset();
      return;
    }
    this.asset.relativePath = null;
    this.formats = [];
    this.quality = [];
    this.textureQuality = [];
    this.httpService.getAssetById(id, this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        this.asset = data;
        this.asset.attributes.uploader = this.asset.attributes.uploader.split("@")[0];
        this.assetFilePath = this.asset.assetfiles[this.asset.assetfiles.length - 1].filePath;
        this.asset.assetfiles.forEach(a => this.formats.push(a.specification.fileFormat));
        this.asset.assetfiles.forEach(a => this.quality.push(a.specification.fileQuality));
        this.asset.assetfiles.forEach(a => this.textureQuality.push(a.specification.textureQuality));
      }, err => {
        console.error(err);
      }
    );
  }

  selectedAssetFile(assetFile: AssetFile) {
    this.assetFilePath = assetFile.filePath;
    this.loadAsset = false;
    setTimeout(() => this.loadAsset = true);
  }

  folderSelected(id) {
  }

  assignAsset(asset: any) {
    this.asset = asset;
  }

  disableContextMenu() {
    this.httpService.contextmenu = false;
  }

  collapseFolder(folder) {
    this.libBrowser.addSubfolder(folder);
  }
}
